import HomeContainer from "src/container/home";
import { Helmet } from "react-helmet-async";

const Home = () => {
  return (
    <>
    <Helmet>
      <title>텔레모아::핵심 텔레그램 채널의 중요 정보를 모아!</title>
      <meta name="description" content="주식, 코인 텔레그램 주요 채널 안내 및 랭킹, 인기 게시글 제공" />
      <meta name="keywords" content="텔레그램 주식" />
    </Helmet>
    <HomeContainer />
    </>
  );
}

export default Home;
